import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { UserLoginMessage } from '@model';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class UserLoginMessagesService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getUserLoginMessages(): Observable<UserLoginMessage[]> {
    return this.http
      .get<UserLoginMessage[]>(`${environment.apiEndpoint}/information/userLoginMessages`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  setLoginMessageAsRead(loginMessageId: Number): Observable<UserLoginMessage> {
    return this.http
      .get<UserLoginMessage>(`${environment.apiEndpoint}/information/LoginMessages/SetRead/${loginMessageId}`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
